import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

const BASE_CLASS = 'mt-CardAd-attrItem'
const BASE_CLASS_ICON = `${BASE_CLASS}Icon`

const ENVIRONMENTAL_LABEL_KEY = 'environmentalLabel'

const CardAdAttribute = ({attribute}) => {
  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const isEnvironmentalLabel = attribute.key === ENVIRONMENTAL_LABEL_KEY
  const hasIcon = Boolean(attribute.icon)

  if (isEnvironmentalLabel) {
    const {environmentalLabels, ENVIRONMENTAL_LABEL_ICONS} = config.get('search')
    const urlStatics = config.get('urlStatics')

    const environmentalLabel = environmentalLabels.find(environmentalLabel => environmentalLabel.id === attribute.value)

    if (!environmentalLabel || attribute.value === 'NO_LABEL') {
      return null
    }

    const environmentalLabelText = environmentalLabel && i18n.t(environmentalLabel.label)

    const environmentalLabelIcon =
      environmentalLabel && `${urlStatics}${ENVIRONMENTAL_LABEL_ICONS[environmentalLabel.id]}`

    return (
      <li className="mt-CardAd-attrItemEnvironmentalLabel">
        <AtomImage src={environmentalLabelIcon} alt={environmentalLabelText} />
      </li>
    )
  }

  if (hasIcon) {
    const Icon = attribute.icon
    return (
      <li className={cx(BASE_CLASS, BASE_CLASS_ICON)}>
        <>
          <Icon id={attribute.id} size="small" title={attribute.title} />
          <div className="mt-CardAd-attrItemIconLabel">{attribute.value}</div>
        </>
      </li>
    )
  }

  return <li className={BASE_CLASS}>{attribute.value}</li>
}

CardAdAttribute.displayName = 'CardAdAttribute'

CardAdAttribute.propTypes = {
  attribute: PropTypes.shape({
    icon: PropTypes.node,
    id: PropTypes.string,
    key: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string
  }).isRequired
}

export default CardAdAttribute
